/*
 * Campaign levels as the API sends them. The level decides whether Campaign Details shows the
 * Included Hotels grid (GAP-1419 E1).
 */
export default {
    HOTEL: 'HOTEL',
    CHAIN: 'CHAIN',
};
